/** @jsxRuntime classic */
/** @jsx createElement */
import { styles } from './styles';
import { createElement, // eslint-disable-line @typescript-eslint/no-unused-vars
DATA_ATTRIBUTE, } from './jsx-runtime';
import { getDisplayableEntries } from './utils';
const ROOT_KEY = 'stats-for-nerds';
const valueKey = (key) => `${key}-value`;
const createEntryElement = (entry) => (createElement("div", { key: entry.key, style: styles.entry },
    createElement("span", { style: styles.entryLabel },
        entry.key,
        ": "),
    createElement("span", { key: valueKey(entry.key), style: styles.entryValue }, entry.formattedValue)));
const initialRender = (container, statsData) => {
    const displayableEntries = getDisplayableEntries(statsData);
    const statsElement = (createElement("div", { style: styles.statsForNerds, key: ROOT_KEY }, displayableEntries.map((entry) => createEntryElement(entry))));
    container.appendChild(statsElement);
};
const updateChangedValues = (container, currentStats, previousStats) => {
    const currentEntries = getDisplayableEntries(currentStats);
    const previousEntries = getDisplayableEntries(previousStats);
    const previousEntriesMap = new Map(previousEntries.map((entry) => [entry.key, entry]));
    const changedEntries = currentEntries.filter((currentEntry) => {
        const previousEntry = previousEntriesMap.get(currentEntry.key);
        return !previousEntry || previousEntry.formattedValue !== currentEntry.formattedValue;
    });
    changedEntries.forEach((entry) => {
        const valueElement = container.querySelector(`[${DATA_ATTRIBUTE}="${valueKey(entry.key)}"]`);
        if (valueElement) {
            valueElement.textContent = entry.formattedValue;
        }
    });
};
const render = (container, statsData, previousStatsData = null) => {
    const statsView = container.querySelector(`[${DATA_ATTRIBUTE}="${ROOT_KEY}"]`);
    if (!statsData.statsForNerdsVisible) {
        statsView?.remove();
        return;
    }
    if (statsView && previousStatsData) {
        updateChangedValues(container, statsData, previousStatsData);
    }
    else {
        statsView?.remove();
        initialRender(container, statsData);
    }
};
export const initializeStatsForNerds = (props) => {
    const { statsForNerdsStore, view, } = props;
    let previousSnapshot = null;
    const unsubscribe = statsForNerdsStore.subscribe(() => {
        const currentSnapshot = statsForNerdsStore.getSnapshot();
        render(view, currentSnapshot, previousSnapshot);
        previousSnapshot = currentSnapshot;
    });
    return () => {
        const statsView = view.querySelector(`[${DATA_ATTRIBUTE}="${ROOT_KEY}"]`);
        statsView?.remove();
        unsubscribe();
    };
};
export * as StatsForNerdsUtils from './utils';
